/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".custom-label[_ngcontent-%COMP%]{letter-spacing:1px;font-size:.7rem;color:#e56c11!important}.text-wrapper[_ngcontent-%COMP%]{float:left;white-space:normal;width:calc(100% - 45px)}"];
export { styles as styles };
